export default {
  title: {
    'approve-success': 'Approve has been Success',
    'reject-success': 'Reject has been Success'
  },
  button: 'Back to Home'
}
